import PersonListeningIcon from './PersonListeningIcon'

export default PersonListeningIcon
